import * as SiIcons from 'react-icons/si';

/**
 * Map of iconName -> React Component
 * Example: { SiReact: SiIcons.SiReact }
 */
export const REACT_ICONS = SiIcons;

/**
 * List of available icon names (for autocomplete)
 */
export const REACT_ICON_NAMES = Object.keys(SiIcons);
